import React, { useEffect, useState } from 'react';
import useTransferEnquiries from '@hooks/transfer-enquiry/useTransferEnquiries';
import { useNavigate, useSearchParams } from 'react-router-dom';
import qs from 'qs';
import TransferEnquiriesTable from '@components/transfer/TransferEnquiriesTable';

const DEFAULT_QUERY = {
    page: 1,
    pageSize: 10,
};

function TransferEnquiriesPage() {
    const { fetching, enquiries, total, fetchEnquiries, abort } = useTransferEnquiries();
    const [query, setQuery] = useState(DEFAULT_QUERY);
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        return () => {
            abort();
        };
    }, []);

    useEffect(() => {
        const query = qs.parse(searchParams.toString());
        setQuery(query);
        fetchEnquiries(query);
    }, [searchParams]);

    const handleTableChange = (pagination, filters, sorter) => {
        setSearchParams({ ...query, page: pagination.current, pageSize: pagination.pageSize });
    };

    const onSelect = (record) => {
        console.log('Selected order:', record);
        navigate(`${record.enquiry.id}`);
    };

    return (
        <div>
            <h3>用车咨询</h3>
            <TransferEnquiriesTable
                enquiries={enquiries}
                total={total}
                query={query}
                loading={fetching}
                handleTableChange={handleTableChange}
                onSelect={onSelect}
            />
        </div>
    );
}

export default TransferEnquiriesPage;
